import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import _ from 'lodash'
import moment from '../../../lib/moment.js'

import { Button } from 'reactstrap'
import { authSelector, divisionSelector, departmentSelector } from './../../../selectors'
import { divisionAction, departmentAction } from './../../../actions/'
import CustomModalMessage from '../../../components/modal-message'
import DivisionForm from '../../../components/division'

class CreateDivision extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      division_code: '',
      division: '',
      department_id: '',
      edit: false,
      id: '',
      activeTab: '1',
      start_date: '',
      is_active: true,
    }
    this.handleInput = this.handleInput.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.deactivateDivision = this.deactivateDivision.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
  }
  componentDidMount() {
    this.props.listDepartment(localStorage.getItem('access_token'))
  }
  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'divisionGet')) {
      this.setState({
        division_code: _.get(nextProps, 'divisionGet.division_code'),
        division: _.get(nextProps, 'divisionGet.name'),
        department_id: _.get(nextProps, 'divisionGet.department_id'),
        start_date: _.get(nextProps, 'divisionGet.start_date') ? _.get(nextProps, 'divisionGet.start_date') : '',
        is_active: _.get(nextProps, 'divisionGet.is_active'),
      })
      this.props.resetGetDivision()
    }
    if (_.get(nextProps, 'edit')) {
      if (_.get(nextProps, 'edit.edit')) {
        this.setState({ id: _.get(nextProps, 'edit.id'), edit: false })
        this.props.handleClickEdit(false, '')
        this.props.getDivision(_.get(nextProps, 'edit.id'), localStorage.getItem('access_token'))
        this.props.resetGetDivision()
      }
      this.setState({
        edit: false,
      })
    }
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleClickEdit() {
    this.setState({ edit: true })
  }
  handleDelete() {
    this.deactivateDivision()
    this.props.cancelDelete()
    this.props.handleSpan(false)
  }
  handleDiscard() {
    this.props.cancelDiscard()
    this.props.handleSpan(false)
  }
  deactivateDivision() {
    this.props.deactivateDivision(_.get(this.state, 'id'), localStorage.getItem('access_token'))
  }
  submitForm() {
    if (_.get(this.state, 'edit')) {
      this.props.editDivision(
        _.get(this.state, 'id'),
        {
          division_code: this.state.division_code,
          name: this.state.division,
          department_id: this.state.department_id,
          start_date: new moment(this.state.start_date),
          is_active: this.state.is_active,
        },
        localStorage.getItem('access_token'))
    }
  }
  render() {
    const button = (
      <div>
        <NewButton outline color="danger" onClick={ () => this.props.showDelete('confirmDelete') }>Delete</NewButton>
        <NewButton color="success" onClick={ this.state.edit ? this.submitForm : this.handleClickEdit }>{ this.state.edit ? 'Save' : 'Edit' }</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )

    return (
      /* eslint no-underscore-dangle: 0 */
      <div>
        {
          _.get(this.props, 'confirmType') === 'confirmDelete' &&
          <CustomModalMessage
            hide={ this.props.cancelDelete }
            show={ _.get(this.props, 'confirmType') === 'confirmDelete' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonDelete }
          />
        }
        { _.get(this.props, 'confirmType') === 'confirmDiscard' &&
        <CustomModalMessage
          hide={ this.props.cancelDiscard }
          show={ _.get(this.props, 'confirmType') === 'confirmDiscard' }
          type={ _.get(this.props, 'confirmStatus') }
          message={ _.get(this.props, 'confirmMessage') }
          button={ buttonDiscard }
        />
        }
        <DivisionForm
          edit={ this.state.edit }
          list={ _.get(this.props, 'listDepartmentData') }
          division_code={ this.state.division_code }
          division={ this.state.division }
          department_id={ this.state.department_id }
          start_date={ this.state.start_date }
          is_active={ this.state.is_active }
          button={ button }
          confrim={ _.get(this.props, 'confirm') }
          submitForm={ this.submitForm }
          handleClickEdit={ this.handleClickEdit }
          handleSpan={ this.props.handleSpan }
          handleInput={ this.handleInput }
          cancelForm={ this.props.cancelForm }
          showDiscard={ this.state.edit ? this.props.showDiscard : () => this.props.handleSpan(false) }
        />
      </div>
    )
  }
}

CreateDivision.propTypes = {
  editDivision: PropTypes.func.isRequired,
  getDivision: PropTypes.func.isRequired,
  listDepartment: PropTypes.func.isRequired,
  resetGetDivision: PropTypes.func.isRequired,
  cancelDelete: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
  cancelDiscard: PropTypes.func.isRequired,
  deactivateDivision: PropTypes.func.isRequired,
  handleClickEdit: PropTypes.func.isRequired,
  showDelete: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getUserData,
  divisionCreate: divisionSelector.getCreateDivisionData,
  divisionEdit: divisionSelector.getEditDivisionData,
  divisionGet: divisionSelector.getGetDivisionData,
  divisionDeactivate: divisionSelector.getDeactivateDivisionData,
  listDepartmentData: departmentSelector.getListDepartment,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  createDivision: divisionAction.createDivision,
  resetCreateDivision: divisionAction.resetCreateDivision,
  editDivision: divisionAction.editDivision,
  resetEditDivision: divisionAction.resetEditDivision,
  getDivision: divisionAction.getDivisionByID,
  resetGetDivision: divisionAction.resetGetDivision,
  listDepartment: departmentAction.getDepartment,
  listDivision: divisionAction.getDivision,
  deactivateDivision: divisionAction.deactivateDivision,
  resetDeactivateDivision: divisionAction.resetDeactivateDivision,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CreateDivision)
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`



// WEBPACK FOOTER //
// ./src/pages/division/edit/index.js